import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PlateregionService {

  private DataRegion:any = [
    {
    seo_val: '',
    text_val: 'регіон'
    }, 
    {
      seo_val: '1',
      text_val: 'АР Крим'
    },
    {
    seo_val: '2',
    text_val: 'Вінницька'
    }, 
    {
    seo_val: '3',
    text_val: 'Волинська'
    }, 
    {
    seo_val: '4',
    text_val: 'Дніпропетровська'
    }, 
    {
    seo_val: '5',
    text_val: 'Донецька'
    }, 
    {
    seo_val: '6',
    text_val: 'Житомирська'
    }, 
    {
    seo_val: '7',
    text_val: 'Закарпатська'
    }, 
    {
    seo_val: '8',
    text_val: 'Запорізька'
    }, 
    {
    seo_val: '9',
    text_val: 'Івано-Франківська'
    }, 
    {
    seo_val: '26',
    text_val: 'м. Київ'
    }, 
    {
    seo_val: '10',
    text_val: 'Київська'
    }, 
    {
    seo_val: '11',
    text_val: 'Кіровоградська'
    }, 
    {
    seo_val: '12',
    text_val: 'Луганська'
    }, 
    {
    seo_val: '13',
    text_val: 'Львівська'
    }, 
    {
    seo_val: '14',
    text_val: 'Миколаївська'
    }, 
    {
    seo_val: '15',
    text_val: 'Одеська'
    }, 
    {
    seo_val: '16',
    text_val: 'Полтавська'
    }, 
    {
    seo_val: '17',
    text_val: 'Рівненська'
    }, 
    {
    seo_val: '18',
    text_val: 'Сумська'
    },
    {
    seo_val: '19',
    text_val: 'Тернопільська'
    }, 
    {
    seo_val: '20',
    text_val: 'Харківська'
    }, 
    {
    seo_val: '21',
    text_val: 'Херсонська'
    }, 
    {
    seo_val: '22',
    text_val: 'Хмельницька'
    }, 
    {
    seo_val: '23',
    text_val: 'Черкаська'
    }, 
    {
    seo_val: '25',
    text_val: 'Чернігівська'
    }, 
    {
    seo_val: '24',
    text_val: 'Чернівецька'
    } 
    //{
    //   seo_val: 'АР Крим',
    //   text_val: 'АР Крим'
    // }
];

getDataRegion() {
  return this.DataRegion;
}

  constructor() { }
}
